import Plyr from 'plyr';

const plyrInit = (el: HTMLElement) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const player = new Plyr(el);
};

export default plyrInit;
